import { TextBadge } from 'ui/components'

import { statusLabel } from '../constants'
import { BSAStatus } from '../types'

export const StatusBadge = ({ status }: { status: string }) => {
  const label = statusLabel[status.toLowerCase()]

  if (!label) {
    return <span>{status}</span>
  }

  switch (status.toLowerCase()) {
    case BSAStatus.NEW:
    case BSAStatus.APPROVED:
    case BSAStatus.ACKNOWLEDGED:
      return <TextBadge color="positive">{label}</TextBadge>
    case BSAStatus.SUBMITTED:
      return <TextBadge color="default">{label}</TextBadge>
    case BSAStatus.WARNINGS:
      return <TextBadge color="warning">{label}</TextBadge>
    case BSAStatus.CANCELLED:
      return <TextBadge color="error">{label}</TextBadge>
  }

  return <TextBadge color="default">{label}</TextBadge>
}
